import { Controller } from '@hotwired/stimulus'

import leaflet from 'leaflet'
import 'leaflet-editable'

leaflet.Marker.prototype.options.icon = leaflet.divIcon({
  html: '<i class="fas fa-map-marker-alt text-lg"></i>',
  iconSize: [30, 30],
  className: 'text-center bg-transparent fs-4 text-primary'
})

export default class extends Controller {
  static targets = ['pointButton', 'polygonButton', 'input', 'preview', 'map']

  elementType = 'Point' // Point or Polygon

  _events = [
    'editable:drawing:commit',
    'editable:dragend',
    'editable:editing'
  ]

  connect () {
    this.map = leaflet.map(this.mapTarget, { editable: true })

    this._events.forEach((event) => {
      this.map.on(event, (e) => {
        this._updateElement(e.layer.toGeoJSON())
      })
    })

    leaflet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.map)

    this.map.setView([62.27, -101.87], 3)

    if (this.inputTarget.value) {
      try {
        const geoJsonFeature = leaflet
          .geoJSON(JSON.parse(this.inputTarget.value))
          .addTo(this.map)
        const element = geoJsonFeature.getLayers()[0]
        element.enableEdit()
        this.elementType = element.feature.geometry.type
        this._updateType()
        this.currentElement = element
        this.map.fitBounds(geoJsonFeature.getBounds(), { maxZoom: 5 })
      } catch (e) {
        console.error(e)
        // clear the input if the value is invalid
        this.inputTarget.value = ''
      }
    } else {
      this._startElement()
    }

    this._renderPreview()
  }

  disconnect () {
    this.map.remove()
  }

  _renderPreview () {
    if (this.inputTarget.value) {
      const geoData = JSON.parse(this.inputTarget.value).geometry
      const coordinates = geoData.type === 'Point'
        ? JSON.stringify(geoData.coordinates)
        : geoData.coordinates[0].map(c => `[${c.join(', ')}]`).join(', ')

      this.previewTarget.value = coordinates ? `${geoData.type} ${coordinates}` : ''
    } else {
      this.previewTarget.value = ''
    }
  }

  _startElement () {
    this.currentElement?.remove()
    this.inputTarget.value = ''
    this._renderPreview()

    console.log(this.elementType)
    if (this.elementType === 'Point') {
      this.currentElement = this.map.editTools.startMarker()
    } else if (this.elementType === 'Polygon') {
      this.currentElement = this.map.editTools.startPolygon()
    }
  }

  _updateElement (geoJSON) {
    this.inputTarget.value = JSON.stringify(geoJSON)
    this._renderPreview()
  }

  _updateType () {
    if (this.elementType === 'Point') {
      this.pointButtonTarget.checked = true
    } else {
      this.polygonButtonTarget.checked = true
    }
  }

  clear () {
    this._startElement()
  }

  setType (event) {
    this.elementType = event.target.value
    this._startElement()
  }
}
